/**
 * api/usage.js — consumo/custo de IA (painel de Custos).
 *
 * GET /dashboard/usage → agrega app.wallet_usage do tenant: totais + breakdown
 * por modelo, por operação (chat/embed), por agente (`byAgent`, SPEC-AGENTES-A4
 * FR-15) e as execuções mais caras. Com `executionId`, tudo se restringe àquela
 * execução (`?execution_id=`). Requer budget_costs:view (mesma superfície do orçamento).
 */
import { useQuery } from '@tanstack/react-query';
import { useApi } from './client';

export function usageUrl(executionId) {
  const eid = (executionId || '').trim();
  return eid ? `/dashboard/usage?execution_id=${encodeURIComponent(eid)}` : '/dashboard/usage';
}

export function useUsageSummary(executionId = null) {
  const api = useApi();
  const eid = (executionId || '').trim() || null;
  return useQuery({
    queryKey: ['usage', 'summary', eid],
    queryFn: () => api.get(usageUrl(eid)),
    staleTime: 30_000,
  });
}
